import { List } from "immutable";

export default {
  privatePlots: [],
  features: [],
  pageable: {},
  points: List(),
  editMode: 0,
};
